export default __webpack_public_path__ + "static/blog-1-shape-3-65779d885fb066fc8d56567e6b91d373.png";